import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizSpin, WizCard, WizRow, WizCol } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/review/lookNotification') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('reviewLookNotification', record)
        } else {
            record = Session.get('reviewLookNotification') || {}
        }
    }
    return record
}

class LookNotification extends WizContainer {

    componentName = 'LookNotification'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record
        }
    }

    _componentDidMount() {
        this._detail()
    }

    _detail = () => {
        const { recordId } = this.state.record
        this.doAction({
            path: 'counselingProcess/preAuditOrCheckDetail',
            payload: {
                key: 'reviewNoticeDetail@' + recordId,
                apiParams: {
                    id: recordId
                }
            }
        })
    }

    render() {
        let { detail, counselingProcessLoading } = this.props
        let { data } = detail
        return (
            <WizSpin spinning={counselingProcessLoading} >
                <WizCard title='查看检核通知'>
                    <div style={{ textAlign: 'center', color: 'red', fontSize: 24, margin: 16 }}>{'检核通知'}</div>
                    <WizRow>
                        <WizCol offset={3} span={18}>
                            <div dangerouslySetInnerHTML={{ __html: data ? data.content : '' }} ></div>
                        </WizCol>
                    </WizRow>
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { recordId } = findParamRecord(ownProps.history)
    const detail = modelUtils.getModelEntity(counselingProcess, 'reviewNoticeDetail@' + recordId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        detail,
        ...loading
    }
}

export default connect(mapStateToProps)(LookNotification)


